import { useState, useEffect } from "react";
import { Box, Button, Typography, IconButton, Slide } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

export default function PWAInstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Daha önce kapatıldıysa gösterme
    if (localStorage.getItem("pwa_dismissed")) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      // 3 saniye sonra banner'ı göster
      setTimeout(() => setShow(true), 3000);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      localStorage.setItem("pwa_dismissed", "1");
    }
    setShow(false);
    setPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem("pwa_dismissed", "1");
    setShow(false);
  };

  if (!show || !prompt) return null;

  return (
    <Slide direction="up" in={show} mountOnEnter unmountOnExit>
      <Box sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        bgcolor: "#1565c0",
        color: "white",
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
        boxShadow: "0 -4px 20px rgba(0,0,0,0.3)",
      }}>
        <PhoneIphoneIcon sx={{ fontSize: 36, flexShrink: 0 }} />
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body1" fontWeight={700} lineHeight={1.2}>
            BIYapayZeka'yı Yükle
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Telefona uygulama olarak ekle, daha hızlı aç
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="small"
          startIcon={<GetAppIcon />}
          onClick={handleInstall}
          sx={{
            bgcolor: "white",
            color: "#1565c0",
            fontWeight: 700,
            flexShrink: 0,
            "&:hover": { bgcolor: "#e3f2fd" },
          }}
        >
          Yükle
        </Button>
        <IconButton size="small" onClick={handleDismiss} sx={{ color: "white", flexShrink: 0 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Slide>
  );
}
